import React from 'react';
import { motion } from 'framer-motion';
import { Sprout, Wind, Flame, Heart, Sun, Briefcase } from 'lucide-react';
const tomos = [{
  n: 'TOMO 1',
  Icon: Sprout,
  title: 'El Despertar Inicial',
  desc: 'Yoga para principiantes'
}, {
  n: 'TOMO 2',
  Icon: Wind,
  title: 'Fluidez Consciente',
  desc: 'Yoga Intermedio I'
}, {
  n: 'TOMO 3',
  Icon: Flame,
  title: 'El Guerrero Interior',
  desc: 'Inversiones y Peak Poses'
}, {
  n: 'TOMO 4',
  Icon: Heart,
  title: 'Yoga para la Vida',
  desc: 'Yoga Terapéutico y Adaptado'
}, {
  n: 'TOMO 5',
  Icon: Sun,
  title: 'La Mente en Calma',
  desc: 'Meditación, Pranayama y Filosofía'
}, {
  n: 'TOMO 6',
  Icon: Briefcase,
  title: 'El Estudio Profesional',
  desc: 'Gestión y Crecimiento para Profesores'
}];
export function TomosGrid() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-228">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-230">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 font-medium text-xs uppercase tracking-widest mb-6 border border-brand-100/50" data-id="element-231">
            6 Tomos completos
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-232">
            Lo que recibís{' '}
            <span className="text-brand-600 italic" data-id="element-233">hoy mismo</span>
          </h2>
          <p className="text-lg text-ink-600 font-light" data-id="element-234">
            Una biblioteca completa de Yoga, secuenciada y lista para aplicar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-235">
          {tomos.map((tomo, i) => {
          const Icon = tomo.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="group relative bg-[#FAF8F5] rounded-[2rem] p-8 lg:p-10 hover:shadow-md transition-all duration-300 overflow-hidden" data-id="element-236">
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-brand-50/50 rounded-bl-full -translate-y-4 translate-x-4 group-hover:bg-brand-50 transition-colors duration-500" data-id="element-237"></div>

                <div className="relative z-10" data-id="element-238">
                  <div className="text-xs font-medium tracking-[0.2em] text-accent-600 mb-6 uppercase" data-id="element-239">
                    {tomo.n}
                  </div>
                  <div className="w-14 h-14 rounded-full bg-white text-brand-700 flex items-center justify-center mb-6 shadow-sm group-hover:scale-105 transition-transform duration-500" data-id="element-240">
                    <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-241" />
                  </div>
                  <h3 className="font-serif font-medium text-2xl text-ink-900 mb-3 leading-tight" data-id="element-242">
                    {tomo.title}
                  </h3>
                  <p className="text-ink-600 leading-relaxed text-sm font-light" data-id="element-243">
                    {tomo.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}